import { CellProps } from './props';
import { GridOptions } from 'ag-grid';
import ActionsCellRenderer from './cell/renderers/actions/component';
import LinkCellRenderer from './cell/renderers/link/component';
import { NumericEditor } from './cell/editors/numeric/component';
import DateCellRenderer from './cell/renderers/date/component';
import CheckCellRenderer from './cell/renderers/check/component';
import WarningCellRenderer from './cell/renderers/warning/component';
import FullnameCellRenderer from './cell/renderers/fullname/component';
import BooleanFilter from './cell/filters/boolean/component';

interface FrameworkComponents {
  [key: string]: {
      new (...args: object[]): object;
  };
}
  
const frameworkComponents: FrameworkComponents = {
  numericEditor: NumericEditor,
  actionsCellRenderer: ActionsCellRenderer,
  linkCellRenderer: LinkCellRenderer,
  dateCellRenderer: DateCellRenderer,
  checkCellRenderer: CheckCellRenderer,
  warningCellRenderer: WarningCellRenderer,
  fullnameCellRenderer: FullnameCellRenderer,
  booleanFilter: BooleanFilter
};

const newCellValueToRedux = (props: CellProps) => {
  if (props.newValue !== props.oldValue && props.context.onEditCell) {
      props.context.onEditCell(props.node.id, props.colDef.field as string, props.newValue);
  }
  return false;
};

export const createDefaults = (rowId: string): GridOptions =>  {
  return {
    columnTypes: {
      textColumn: {
        editable: false, 
        newValueHandler: newCellValueToRedux,
        cellClass: 'cell-class'
      },
      fullnameColumn: {
        editable: false, 
        cellRenderer: 'fullnameCellRenderer',
        newValueHandler: newCellValueToRedux,
        cellClass: 'cell-class'
      },
      numberColumn: {
        editable: false,
        type: 'numericColumn',
        cellEditor: 'numericEditor',
        newValueHandler: newCellValueToRedux,
        cellClass: 'cell-class'
      },
      dateColumn: {
        headerName: '',
        cellRenderer: 'dateCellRenderer',
        editable: false,
        newValueHandler: newCellValueToRedux, 
        cellClass: 'cell-class'
      },
      infoIconColumn: {
        headerName: '',
        cellRenderer: 'infoIconRenderer',
        width: 20,
        editable: false,
        cellClass: 'cell-class'
      },
      productNameColumn: {
        headerName: '',
        cellRenderer: 'productName',
        width: 150,
        editable: false,
        cellClass: 'cell-class'
      },
      actionsColumn: {
        headerName: '',
        cellRenderer: 'actionsCellRenderer',
        width: 35,
        suppressFilter: true,
        suppressAutoSize: true,
        suppressSorting: true,
        suppressMovable: true,
        suppressResize: true,
        suppressNavigable: true,
        cellRendererParams: [],
        cellClass: 'cell-class'
      },
      linkColumn: {
        headerName: '',
        cellRenderer: 'linkCellRenderer',
        cellRendererParams: {},
        editable: false,
        headerClass: 'left-content-header',
        cellClass: 'left-content-cell cell-class'
      },
      statusIconColumn: {
        headerName: '',
        cellRenderer: 'statusCellRenderer',
        width: 125,
        editable: false,
        cellClass: 'cell-class'
      },
      mobileItemColumn: {
        cellRenderer: 'mobileItemCellRenderer',
        cellClass: 'cell-class',
        editable: false,
        width: 100,
        autoHeight: true
      },
      desktopItemColumn: {
        cellRenderer: 'desktopItemCellRenderer',
        cellClass: 'cell-class',
        editable: false,
        width: 100,
        autoHeight: true
      },
      checkColumn: {
        cellRenderer: 'checkCellRenderer',
        cellClass: 'cell-class',
        editable: false,
        width: 25,
        autoHeight: true
      },
      warningColumn: {
        cellRenderer: 'warningCellRenderer',
        cellClass: 'cell-class',
        editable: false,
        width: 25,
        autoHeight: true
      }
    },
    frameworkComponents: frameworkComponents,
    deltaRowDataMode: true,
    getRowNodeId: data => data[rowId],
    enableSorting: false,
    enableFilter: false,
    enableColResize: false,
    animateRows: false,
    paginationAutoPageSize: true,
    pagination: false,
    rowSelection: 'single',
    suppressHorizontalScroll: true,
    suppressScrollOnNewData: true,
    maxConcurrentDatasourceRequests: 2,
    maxBlocksInCache: 2,
    cacheOverflowSize: 2,
    infiniteInitialRowCount: 1,
    paginationPageSize: 100,
    rowModelType: 'clientSide', // use 'infinite' for ajax data,
    localeText: {noRowsToShow: ' '},
  };
};


// WEBPACK FOOTER //
// ./src/components/user-grid/types.ts